export default "__VITE_ASSET__BmmLGLB$__"